import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import dayjs from 'dayjs'
import VueWaypoint from 'vue-waypoint'
import VueTruncate from 'vue-truncate-filter'
import LazyLoad from 'vanilla-lazyload'
import VueScrollactive from 'vue-scrollactive'
import HoverIntent from 'vue2-hover-intent';
var VueScrollTo = require('vue-scrollto')

Vue.use(VueScrollTo, {
  offset: -48
})
Vue.use(VueTruncate)
Vue.use(VueScrollactive)
Vue.use(VueWaypoint)

Vue.directive('hover-intent', HoverIntent)

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})

// Vue.use(VueLazyload, {
//   adapter: {
//     loaded ({ bindType, el, naturalHeight, naturalWidth, $parent, src, loading, error, Init }) {
//             // do something here
//             // example for call LoadedHandler
//           },
//           loading (listender, Init) {
//             // console.log(listender)
//             console.log('loading')
//           },
//           error (listender, Init) {
//             // console.log(listender)
//             // console.log(Init)
//           }
//         }
// })

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    siteDescription: function () {
      return 'Founded in 2021 in Berlin as a non-governmental, not-for-profit association (e.V.), Forensis works for and in collaboration with individuals and communities affected by state and corporate violence, to support their demands for justice, reparations, and accountability.'
    },
    titleCase: function (str) {
      str = str.toLowerCase().split(' ').map(function(word) {
        return (word.charAt(0).toUpperCase() + word.slice(1))
      })
      return str.join(' ')
    },
    lazyLoad: function (args) {
      return new LazyLoad(args)
    },
    clearNewLines: function (text) {
      if (text) {
        return text.replace(/(\r\n\t|\n|\r\t)/gm,"")
      } else {
        return ''
      }
    },
    isMobileWidth: function () {
      if (window.matchMedia('screen and (max-width:40em)').matches) {
        return true
      } else {
        return false
      }
    },
    flattenArray: function (items) {
      if (items) {
        return items.map(x => {
          return x.post_title
        }).join(', ')
      } else {
        return '-'
      }

    },
    forumTitles: function (investigation, preferFreetext = false) {
      if (investigation.forum) {
        if (preferFreetext && investigation.forum_freetext) {
          return investigation.forum_freetext
        } else if (typeof(investigation.forum) === "object") {
          return investigation.forum.join(', ')
        } else {
          return '-'
        }
      } else {
        return ''
      }
    },
    getVideoPoster (videoObject) {
      if (videoObject !== undefined && videoObject !== "") {
        let videoJSON = JSON.parse(videoObject)
        let item = videoJSON.pictures.sizes.find(pic => pic.width === 1920)
        return item
      } else {
        return {
          link: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPc8h8AAm0BtR3QMUIAAAAASUVORK5CYII="
        }
      }
    },
    getVideoSrc (videoObject, quality) {
      let videoJSON = JSON.parse(videoObject)
      let file = videoJSON.files.find(file => file.quality === quality)
      return file['link']
    },
    preventWidows (text) {
      if (text) {
        return text.replace(/ ([^ ]*)$/,'&nbsp;'+'$1')
      } else {
        return text
      }
    },
    dateIsBefore (date) {
      return dayjs().isBefore(dayjs(date))
    },
    unSlug (text) {
      return text.replace(/-/g, ' ')
    }
  }
})

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
